import { z } from "zod";

export const campaignsSchema = z.object({
  campaignId: z.string(),
  fix: z.boolean(),
  contractStartDate: z.nullable(z.string()),
  closeBilling: z.nullable(z.string()),
  bannerTemplateCode: z.nullable(z.string()),
  identification: z.boolean().default(false),
});

export type Campaigns = z.infer<typeof campaignsSchema>;
